import { Button } from "primereact/button";
import { Tag } from "primereact/tag";

import { EmptyState, ErrorState, ForbiddenState, StateMessage } from "@/ds";
import {
  ANEXO_BAIXAR_LABEL,
  ANEXO_VER_LABEL,
  ANEXOS_LOADING_LABEL,
  ANEXOS_VAZIO_TITULO,
} from "./ficha-anexos.constants";
import styles from "./ficha-anexos.module.scss";
import type { FichaAnexosViewModel } from "./types-ficha-anexos";

/** Título e a relação de anexos (identificação, formato, tamanho; só ver e baixar). */
export function FichaAnexosView({
  title,
  status,
  errorMessage,
  recarregar,
  linhas,
  baixarArquivo,
  verArquivo,
}: FichaAnexosViewModel) {
  return (
    <section
      className={styles.secao}
      data-section-id="anexos"
      aria-labelledby="ficha-anexos-titulo"
      data-testid="ficha-section-anexos"
    >
      <div className={styles.cabecalho}>
        <h3 className={styles.titulo} id="ficha-anexos-titulo">
          {title}
        </h3>
      </div>

      {status === "loading" ? (
        <StateMessage
          variant="loading"
          title={ANEXOS_LOADING_LABEL}
          testId="ficha-anexos-loading"
        />
      ) : null}

      {status === "forbidden" ? (
        <ForbiddenState description={errorMessage ?? undefined} testId="ficha-anexos-error" />
      ) : null}

      {status === "error" ? (
        <ErrorState
          message={errorMessage ?? undefined}
          onRetry={recarregar}
          testId="ficha-anexos-error"
        />
      ) : null}

      {status === "success" && linhas.length === 0 ? (
        <EmptyState.Root size="sm" testId="ficha-anexos-empty" className={styles.vazio}>
          <EmptyState.Illustration name="sem-equipe" />
          <EmptyState.Title>{ANEXOS_VAZIO_TITULO}</EmptyState.Title>
        </EmptyState.Root>
      ) : null}

      {status === "success" && linhas.length > 0 ? (
        <ul className={styles.lista} data-testid="ficha-anexos-lista">
          {linhas.map((linha) => (
            <li key={linha.id} className={styles.item} data-testid={linha.testIds.linha}>
              <span className={styles.identificacao}>{linha.identificacao}</span>
              <Tag value={linha.formato} severity="secondary" />
              <span className={styles.tamanho}>{linha.tamanho}</span>
              <span className={styles.acoes}>
                <Button
                  type="button"
                  icon="pi pi-eye"
                  text
                  severity="secondary"
                  aria-label={`${ANEXO_VER_LABEL}: ${linha.identificacao}`}
                  onClick={() => verArquivo(linha.id)}
                  data-testid={linha.testIds.ver}
                />
                <Button
                  type="button"
                  icon="pi pi-download"
                  text
                  severity="secondary"
                  aria-label={`${ANEXO_BAIXAR_LABEL}: ${linha.identificacao}`}
                  onClick={() => baixarArquivo(linha.id)}
                  data-testid={linha.testIds.baixar}
                />
              </span>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
